import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Car, Mail } from 'lucide-react';

const LOGO_URL = '/advecti-logo.png';

const Footer = () => {
  return (
    <footer className="bg-navy text-cream" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Advecti" 
              className="h-20 w-auto mb-4 bg-cream rounded-lg p-2"
            />
            <p className="text-cream max-w-md">
              Advecti connects drivers looking to earn extra income with businesses 
              seeking affordable, high-impact mobile advertising in the Columbus metropolitan area.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-cream hover:text-gold transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-cream hover:text-gold transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/for-drivers" className="text-cream hover:text-gold transition-colors">
                  For Drivers
                </Link>
              </li>
              <li>
                <Link to="/for-advertisers" className="text-cream hover:text-gold transition-colors">
                  For Advertisers
                </Link>
              </li>
              <li>
                <Link to="/get-started" className="text-cream hover:text-gold transition-colors">
                  Get Started
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-cream hover:text-gold transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/contact"
                  className="flex items-center gap-2 text-cream hover:text-gold transition-colors"
                  data-testid="footer-contact-link"
                >
                  <Mail size={18} />
                  <span>Send us a message</span>
                </Link>
              </li>
              <li className="flex items-center gap-2 text-cream">
                <MapPin size={18} />
                <span>Columbus Metropolitan Area</span>
              </li>
              <li className="flex items-center gap-2 text-cream">
                <Car size={18} />
                <span>Mobile Advertising</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-cream/20 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-0">
          <p className="text-cream text-sm">
            © {new Date().getFullYear()} Advecti. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs">
            <Link to="/privacy" className="text-cream/50 hover:text-gold transition-colors" data-testid="footer-privacy-link">
              Privacy
            </Link>
            <Link to="/terms" className="text-cream/50 hover:text-gold transition-colors" data-testid="footer-terms-link">
              Terms
            </Link>
            <span className="text-cream/50">Advertising on Cars in Columbus, Ohio</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
